import { FaqGroup } from '../../components/Landing/FAQsPage/FaqLayout/types';

export const FAQS_MOCK: FaqGroup[] = [
    {
        id: 'faq-sobre',
        title: 'faqs.groups.about.title',
        intro: 'faqs.groups.about.intro',
        items: [
            { q: 'faqs.q1', a: 'faqs.a1' },
            { q: 'faqs.q2', a: 'faqs.a2' },
            { q: 'faqs.q3', a: 'faqs.a3' },
            { q: 'faqs.q4', a: 'faqs.a4' },
            { q: 'faqs.q5', a: 'faqs.a5' },
        ]
    },
    {
        id: 'faq-registro',
        title: 'faqs.groups.registration.title',
        intro: 'faqs.groups.registration.intro',
        items: [
            { q: 'faqs.q6', a: 'faqs.a6' },
            { q: 'faqs.q7', a: 'faqs.a7' },
            { q: 'faqs.q8', a: 'faqs.a8' },
        ]
    },
    {
        id: 'faq-consultas',
        title: 'faqs.groups.bookings.title',
        intro: 'faqs.groups.bookings.intro',
        items: [
            { q: 'faqs.q9', a: 'faqs.a9' },
            { q: 'faqs.q10', a: 'faqs.a10' },
            { q: 'faqs.q11', a: 'faqs.a11' },
            { q: 'faqs.q12', a: 'faqs.a12' },
            { q: 'faqs.q13', a: 'faqs.a13' },
        ]
    },
    {
        id: 'faq-planes',
        title: 'faqs.groups.plans.title',
        intro: 'faqs.groups.plans.intro',
        items: [
            { q: 'faqs.q14', a: 'faqs.a14' },
            { q: 'faqs.q15', a: 'faqs.a15' },
            { q: 'faqs.q16', a: 'faqs.a16' },
            { q: 'faqs.q17', a: 'faqs.a17' },
        ]
    },
    {
        id: 'faq-privacidad',
        title: 'faqs.groups.privacy.title',
        intro: 'faqs.groups.privacy.intro',
        items: [
            { q: 'faqs.q18', a: 'faqs.a18' },
            { q: 'faqs.q19', a: 'faqs.a19' },
            { q: 'faqs.q20', a: 'faqs.a20' },
        ]
    },
    {
        id: 'faq-profesionales',
        title: 'faqs.groups.professionals.title',
        intro: 'faqs.groups.professionals.intro',
        items: [
            { q: 'faqs.q21', a: 'faqs.a21' },
            { q: 'faqs.q22', a: 'faqs.a22' },
            { q: 'faqs.q23', a: 'faqs.a23' },
            { q: 'faqs.q24', a: 'faqs.a24' },
        ]
    }
];
